import { useRecordContext } from 'react-admin';
import { Button } from '@mui/material';

const CustomEditButton = ({ handleEdit }) => {
    const record = useRecordContext(); 
    
    if (!record) return null; 

    return (
        <Button
            onClick={() => handleEdit(record)}
            variant="contained"
            color="primary"
        >
            Edit
        </Button>
    );
};

export default CustomEditButton;
